import {
  AllergenEnum,
  DayOfWeek,
  DishDto,
  FluiditeTauxOccupationValues,
  FormulaDto,
  GetSurveyResult,
  MenuDto,
  OrderSettingsDto,
  RestaurantContactDto,
  RestaurantDisplaySettings,
  RestaurantServiceValues,
  RestaurantSousTypeValues,
  RestaurantTypeValues,
  SurveyCampaignDto,
} from '@timechef/core/api';

export interface Restaurant {
  openedAt?: Date;
  closedAt?: Date;
  closedFrom?: Date;
  closedTo?: Date;
  hasFluidite: boolean;
  hasMenu: boolean;
  fluidite: FluiditeTauxOccupationValues;
  fluiditeDetails?: FluiditeDetails;
  id: number;
  openedDays: Array<DayOfWeek>;
  title: string;
  type: RestaurantTypeValues;
  sousType?: RestaurantSousTypeValues;
  typeLabel: string;
  imageUrl?: string;
  animationId?: number;
  surveyCampaign?: SurveyCampaignDto;
  surveyCampaignDetails?: GetSurveyResult;
  isOpen: boolean;
  isExceptionallyClosed: boolean;
  menus: Menu[];
  orderSettings?: OrderSettingsDto;
  contact?: RestaurantContactDto;
  description?: string;
  allowOrder: boolean;
  allowOrderHistory: boolean;
  hasExternalOrderHistory: boolean;
  isExternalServiceATable: boolean;
  allowComments: boolean;
  isExternalCameraAllowed: boolean;
  displaySettings?: RestaurantDisplaySettings | null;
}

export interface FluiditeDetails {
  rates: FluiditeRate[];
  capacity?: number;
  remainingSeats?: number;
}

export interface FluiditeRate {
  startsAt: Date;
  endsAt: Date;
  lastWeekRate: number;
  currentWeekRate?: number;
  currentRate?: number;
  showStartLabel: boolean;
  showEndLabel: boolean;
}

export interface SiteNews {
  id: number;
  title: string;
  imageUrl: string;
}

export interface Allergen {
  label?: string;
  enum: AllergenEnum;
  svg?: string;
}

export interface RestaurantMenuCardInfos {
  id: number;
  imageUrl?: string | null;
  label: string;
  description: string;
  allergenes: string[];
  prix: number;
  nutriscore: string;
  calories: number;
}

export enum DishInformationEnum {
  Nutriscore = 'Nutriscore',
  Carbonscore = 'Carbonscore',
  Greenscore = 'Greenscore',
  Calories = 'Calories',
  Stand = 'Stand',
  Veggie = 'Veggie',
  PorkFree = 'PorkFree',
}
export interface CartItem {
  price: number;
  dishId: number;
  dishLabel: string;
  quantity: number;
  isIncludedInMenu: boolean;
}

export interface CartFormula {
  formulaId: number;
  tempFormulaGuid: string;
  formulaLabel: string;
  quantity: number;
  price: number;
  dishes: CartFormulaDish[];
}

export interface CartFormulaDish {
  sectionId: number;
  dishId: number;
  dishLabel: string;
  quantity: number;
}

export interface DisplayableCart {
  date: Date;
  items: CartItem[];
  formulas: CartFormula[];
  admission: number;
  totalTTC: number;
  service: RestaurantServiceValues;
}

export interface Menu extends MenuDto {
  timedOut: boolean;
  pickupLimitDate?: Date;
}

export interface SelectableMenu {
  date: string;
  dishFamilies: Array<SelectableDishFamily>;
  formulas: Array<SelectableFormula> | undefined;
  isClosed: boolean;
  order: string[];
  organized?: Array<SelectableDishFamily>;
  displaySettings: MenuDisplaySettings;
}

export interface MenuDisplaySettings {
  hideDishFamilyFilters: boolean;
  showDescription: boolean;
}

export interface SelectableDishFamily {
  dishes: Array<SelectableDish>;
  dishesByComposantesMenus: Array<SelectableSubDishFamily>;
  label: string;
  maxItemsAllowed: number;
  isMaxItemsReached: boolean;
  externalRef: string;
}

export interface SelectableSubDishFamily {
  label: string;
  dishes: Array<SelectableDish>;
}

export interface SelectableFormula extends FormulaDto {
  selectable: SelectionData;
}

export interface SelectableDish extends DishDto {
  selectable?: SelectionData;
}

export interface SelectionData {
  amountInCart: number;
  maxAllowedInCart: number;
  canBeAdded: boolean;
  canBeRemoved: boolean;
}

export interface RestaurantServiceData {
  service: RestaurantServiceValues;
  existingOrderId: number | null;
}

export interface MenuFilterCategory {
  label: string;
  ref: string;
}

export const LAST_CLICKED_RESTAURANT_RETENTION = 10;

export interface InitCartOptions {
  restaurantId: number;
  date: Date;
  pickupLimitDate?: Date;
  service: RestaurantServiceValues;
  allowCartRetrieval: boolean;
}
